import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        formCategory: '='
    },
    template: `
        <div class="col00">
            <div class="heading01 type01">
                <ul class="actions01">
                    <li>
                        <forms-settings-formcategories-translation ng-if="vm.QuestionService.canManageQuestionRelatedData()" form="vm.form" form-category="vm.formCategory"/>
                    </li>
                    <li>
                         <a ui-sref="authorized.forms.settings.formcategories.list()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a>
                    </li>
                </ul>
                <h1>{{ vm.form.model.activeI18n.name }}</h1>
            </div>
            <div class="well">
                <h2>{{ 'formCategory.General data' | translate }}</h2>
                <form>
                <div class="form">
                    <forms-settings-formcategories-generaldata form="vm.form"></forms-settings-formcategories-generaldata>
                </div>
                </form>
            </div>
            <!--<div class="well color02 todo">-->
                <!--<h2>Forms</h2>-->
                <!--<table class="data01" datatable dt-options="vm.tableOptions">-->
                    <!--<thead>-->
                    <!--<tr>-->
                        <!--<th>Name</th>-->
                        <!--<th>Status</th>-->
                    <!--</tr>-->
                    <!--</thead>-->
                    <!--<tbody>-->
                    <!--<tr>-->
                        <!--<td><a ui-sref="forms.form.list()" ui-sref-opts="{ location: 'replace' }">Interview for the UX</a></td>-->
                        <!--<td>Active</td>-->
                    <!--</tr>-->
                    <!--<tr>-->
                        <!--<td><a ui-sref="forms.questions.category.question.general()" ui-sref-opts="{ location: 'replace' }">Interview for the project managers</a></td>-->
                        <!--<td>Active</td>-->
                    <!--</tr>-->
                    <!--<tr>-->
                        <!--<td><a ui-sref="forms.questions.category.question.general()" ui-sref-opts="{ location: 'replace' }">Interview for the developers</a></td>-->
                        <!--<td>Active</td>-->
                    <!--</tr>-->
                    <!--</tbody>-->
                <!--</table>-->
            <!--</div>-->
            <ul class="actions01">
                <li ng-if="vm.QuestionService.canManageQuestionRelatedData()"><a class="btn main" ng-click="vm.save()">{{ 'general.Save' | translate }}</a></li>
                <li><a ui-sref="authorized.forms.settings.formcategories.list()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($state, FormFactory, QuestionService) {
        this.$state = $state;
        this.QuestionService = QuestionService;
        this.form = FormFactory.create(this.formCategory, model => model.$update({ id: model.id }));
    }

    save () {
        this.form.save()
            .then(() => {
                this.$state.go('authorized.forms.settings.formcategories.list');
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/formcategories/edit/index.js